var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57852 1.5375L9.12852 0.9875C9.77852 0.3375 10.9098 0.3375 11.5598 0.9875L12.0035 1.43125C12.3285 1.75625 12.5098 2.1875 12.5098 2.64375C12.5098 3.1 12.3285 3.5375 12.0035 3.85625L11.4535 4.40625L8.57852 1.53125V1.5375ZM7.91602 2.2L2.22227 7.89375C2.04102 8.075 1.92852 8.3125 1.90977 8.56875L1.74102 10.4C1.72227 10.6313 1.80352 10.8562 1.96602 11.025C2.11602 11.175 2.30977 11.2562 2.51602 11.2562H2.58477L4.41602 11.0875C4.67227 11.0625 4.90977 10.95 5.09102 10.7688L10.7848 5.075L7.90977 2.2H7.91602ZM13.7598 13.25C13.7598 12.9937 13.5473 12.7812 13.291 12.7812H0.791016C0.534766 12.7812 0.322266 12.9937 0.322266 13.25C0.322266 13.5062 0.534766 13.7188 0.791016 13.7188H13.291C13.5473 13.7188 13.7598 13.5062 13.7598 13.25Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconPen);
export default __webpack_public_path__ + "static/media/edit-icon-pen.08c7268b3411070505c4d8e7f0e1b0ad.svg";
export { ForwardRef as ReactComponent };